import Service from "./Service";
import { API_URL } from "../config";

const resource = `${API_URL}/bankAccounts`;

export default {
  getAllBanks() {
    return Service.get(`${resource}`, {
      // headers: {
      //     Authorization: `Bearer ${token}`,
      // },
    }).then((response) => {
      // if (response.data.done) {
      return response.data.data;
      // }
    });
  },
};
